export default {
  init($) {
    // JavaScript to be fired on the home page
  },
  finalize($) {
    // JavaScript to be fired on the home page, after the init JS
    {
      $('.story[data-toggle="modal"]').hover(
        function () {
          let datatarget = $(this).attr('data-target');
          $('.wrap-logo[data-target="'+ datatarget +'"]').addClass('active');
      },
        function(){
          let datatarget = $(this).attr('data-target');
          $('.wrap-logo[data-target="'+ datatarget +'"]').removeClass('active');
        });

      $('.wrap-logo[data-toggle="modal"]').hover(
        function () {
          let datatarget = $(this).attr('data-target');
          $('.story[data-target="'+ datatarget +'"]').addClass('active');
        },
        function(){
          let datatarget = $(this).attr('data-target');
          $('.story[data-target="'+ datatarget +'"]').removeClass('active');
        });
    }
  },
};
